import React from "react";
import {
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import "dayjs/locale/zh-tw";
import { useTranslation } from "react-i18next";
import emissionViewStore from "../../Store/marco/emissionViewStore";
import commonStore from "../../Store/marco/commonStore";
import { observer } from "mobx-react";
import {
  calendarPeriod,
  isDateInPeriod,
  isMonthInPeriod,
  isYearInPeriod,
  pickerBounds,
} from "../utils/reportingPeriod";

export const CustomDatePicker = observer(({
  label,
  value,
  handleChange,
  error,
  dataFormat,
  disabled,
}) => {
  const { t } = useTranslation("ActivityMain");
  const adapterLocale = commonStore.lang === "zh_tw" ? "zh-tw" : "en";
  const dateValue = value ? dayjs(value) : null;

  const selectedYear = emissionViewStore.selectedYear;
  const period =
    emissionViewStore.reportingPeriod ?? calendarPeriod(selectedYear);
  const { minDate, maxDate } = pickerBounds(selectedYear);
  // Year 格式不顯示也不驗證日期，避免預設值落在期間外而出現錯誤狀態
  const periodRestrictions =
    dataFormat === 2
      ? {}
      : {
          shouldDisableYear: (date) => !isYearInPeriod(date, period),
          shouldDisableMonth: (date) => !isMonthInPeriod(date, period),
          shouldDisableDate:
            dataFormat === 3
              ? (date) => !isDateInPeriod(date, period)
              : undefined,
        };

  return (
    <FormControl fullWidth sx={{ my: 1, minWidth: 80 }} error={error}>
      <Typography sx={{ marginBottom: 1 }}>
        <span style={{ color: "red" }}>*</span> {label}
      </Typography>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={adapterLocale}
      >
        <DesktopDatePicker
          minDate={minDate}
          maxDate={maxDate}
          {...periodRestrictions}
          value={dateValue}
          onChange={handleChange}
          format={
            dataFormat === 1
              ? "YYYY-MM"
              : dataFormat === 3
                ? "YYYY-MM-DD"
                : "YYYY"
          }
          views={
            dataFormat === 1 ? ["year", "month"] : ["year", "month", "day"]
          }
          openTo={dataFormat === 1 ? "month" : "day"}
          referenceDate={dateValue ?? period.start}
          disabled={dataFormat === 2 || disabled}
          slotProps={{
            textField: {
              error: error, // 將 error 傳遞給 TextField
              fullWidth: true,
              sx: {
                "& .MuiInputLabel-root.Mui-focused": {
                  display: "none",
                },
                "& .MuiSvgIcon-root": {
                  color: "green",
                },
              },
            },
            desktopPaper: {
              sx: {
                // 針對內部的 Calendar Root 移除固定高度
                "& .MuiDateCalendar-root": {
                  height: "auto", // 移除 336px，改為自動適應內容
                  maxHeight: "none", // 確保不會被限制
                },
              },
            },
          }}
        />
      </LocalizationProvider>
      {error && <FormHelperText>{t("Please enter value")}</FormHelperText>}
    </FormControl>
  );
});
